import { forwardRef } from "react";
import { MaskedTextInput as RNMaskedTextInput } from "react-native-mask-text";
import { StyleSheet, FlatList, ScrollView as RNScrollView, FlatListProps, TextInput as RNTextInput } from "react-native";
import {
  IconButton as PaperIconButton,
  Button as PaperButton,
  Checkbox,
  HelperText as PaperHelperText,
  Avatar,
  Chip as PaperChip,
  Menu as PaperMenu,
  Card as PaperCard,
} from "react-native-paper";
import { styled } from "nativewind";

/**
 * You should probably
 * @see ./Button
 * instead of using this directly
 */
export const StyledButton = styled(PaperButton, {
  props: {
    labelStyle: true,
    contentStyle: true,
  },
});

export const CheckboxItem = styled(Checkbox.Item, { props: { labelStyle: true } });
export const Chip = styled(PaperChip, { props: { textStyle: true } });

export function flatList<T>() {
  return styled<FlatListProps<T>, "contentContainerStyle", "contentContainerStyle">(FlatList, {
    props: { contentContainerStyle: true },
  });
}

export const IconButton = styled(PaperIconButton);
export const HelperText = styled(PaperHelperText);
export const AvatarText = styled(Avatar.Text, { props: { labelStyle: true } });

export const ScrollView = styled(RNScrollView, { props: { contentContainerStyle: true } });

type MaskedInputProps = React.ComponentPropsWithoutRef<typeof RNMaskedTextInput>;

export const MaskedTextInput = styled(
  forwardRef<RNTextInput, MaskedInputProps>(({ style, ...props }, ref) => (
    <RNMaskedTextInput style={StyleSheet.flatten(style)} {...props} ref={ref} />
  ))
);

export const Menu = styled(PaperMenu, { props: { contentStyle: true } });

export const CardTitle = styled(PaperCard.Title, { props: { subtitleStyle: true, titleStyle: true } });
export const Card = styled(PaperCard, { props: { contentStyle: true } });
export const CardContent = PaperCard.Content;
